import { showHttpError } from '@calendly/alert'
import { httpRequest } from '@calendly/http-tools'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { createSelector } from 'reselect'

export const fetchStatistics = createAsyncThunk(
  'workflows/ownerStatistics/fetchData',
  async ({ userId, workflowsExtractionEnabled }, { dispatch, rejectWithValue }) => {
    const url = workflowsExtractionEnabled
      ? '/api/apps/workflows/statistics'
      : '/api/workflows/owner_statistics'
    const params = workflowsExtractionEnabled ? null : { user_id: userId }

    const [success, response] = await httpRequest({
      url,
      method: 'GET',
      params
    })
    if (!success) {
      dispatch(showHttpError(response))
      return rejectWithValue(null)
    }

    return response
  }
)

const slice = createSlice({
  name: 'workflows/ownerStatistics',
  initialState: {
    loadingState: 'initial',
    personalWorkflowsCount: null,
    teamWorkflowsCount: null
  },
  reducers: {
    workflowDeleteSuccess: (state, {
      payload: { owner: { type } }
    }) => {
      switch (type) {
        case 'user':
          state.personalWorkflowsCount -= 1
          break
        case 'page':
          state.teamWorkflowsCount -= 1
          break
        default: break
      }
    }
  },
  extraReducers: (builder) => {
    builder.addCase(fetchStatistics.pending, (state) => {
      state.loadingState = 'loading'
    })
    builder.addCase(fetchStatistics.fulfilled, (state, { payload }) => ({
      personalWorkflowsCount: payload.personal_workflows_count,
      teamWorkflowsCount: payload.team_workflows_count,
      loadingState: 'loaded'
    }))
    builder.addCase(fetchStatistics.rejected, (state) => {
      state.loadingState = 'failed'
    })
  }
})

const workflowsSelector = ({ workflows }) => workflows
const ownerStatisticsSelector = createSelector(
  workflowsSelector,
  ({ ownerStatistics }) => ownerStatistics
)
export const ownerStatisticsIsLoadedSelector = createSelector(
  ownerStatisticsSelector,
  ({ loadingState }) => loadingState === 'loaded'
)
export const ownerStatisticsIsFailedSelector = createSelector(
  ownerStatisticsSelector,
  ({ loadingState }) => loadingState === 'failed'
)
export const personalWorkflowsCountSelector = createSelector(
  ownerStatisticsSelector,
  ({ personalWorkflowsCount }) => personalWorkflowsCount
)
export const teamWorkflowsCountSelector = createSelector(
  ownerStatisticsSelector,
  ({ teamWorkflowsCount }) => teamWorkflowsCount
)

export const { reducer, actions: { workflowDeleteSuccess } } = slice
